import React, {useRef} from "react";
import {Box, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {HorizontalBar} from "react-chartjs-2";

import PieChart from '@user-components/PieChart';
/**
 * 균형상태 분석 - 파이 차트 + RAW/BAND 차이 바차트
 * @param {*} props
 */
export default function BrainBalanceMap(props) {
    const classes = useStyles();
    const chartRef = useRef()
    const labels = ['δ','θ','α','SMR','β', 'βM', 'βh']
    const {bandRangeData, width, height, circleWidth, fontSize} = props;

    // RAW/BAND 차이값 계산
    const ch1 = bandRangeData.ch1.map(v => parseFloat(v));
    const ch2 = bandRangeData.ch2.map(v => parseFloat(v));
    const leftTotal = ch1.reduce((sum, v) => sum + v, 0);
    const rightTotal = ch2.reduce((sum, v) => sum + v, 0);
    const rawDiff = parseFloat((rightTotal - leftTotal).toFixed(2));
    const bandDiff = parseFloat((ch2[0] - ch1[0]).toFixed(2));

    return <Box style={{width, height, marginTop: 40}}>
        <Grid container justify={ 'center' } spacing={2} >
            { labels.map((label, index) => {
                const c1 = bandRangeData.ch1[index];
                const c2 = bandRangeData.ch2[index];
                const total = parseFloat(c1) + parseFloat(c2)
                const ch1Percent = 0 === total ? 50 : Math.floor(c1 / total * 100)
                const ch2Percent = 100 - ch1Percent;


                return <Grid item key={ Math.random() * 100 } >
                    <PieChart 
                        ref={ chartRef }
                        colors={['#BEF3B0', '#FF00A5']}
                        useColorIndex={true}
                        defaultData={[ch2Percent, ch1Percent]}
                        labels={['우: ' + ch2Percent,'좌: ' + ch1Percent]}
                        labelsReverse={true}
                        height={height ? height : 200}
                        width={circleWidth ? circleWidth : 150}
                        xLabelDisplay={true}
                        legendPosition={'bottom'}
                        title={label}
                        fontSize={fontSize ? fontSize : 14}/>
                </Grid>
            }) }
        </Grid>

        {/* RAW / BAND 좌우 차이 바차트 */}
        <Box mt={6}>
            <Typography variant={'subtitle1'} className={classes.diffTitle} style={{marginLeft: 58}}>
                좌우 차이
            </Typography>
            <Box mt={2}>
                <Box mb={1} display={'flex'} alignItems={'center'}>
                    <Typography variant={'subtitle2'} className={classes.diffLabel}>RAW</Typography>
                    <Box flex={1}>
                        <DiffBarChart
                            labels={['RAW']}
                            data={[rawDiff]}
                            colors={[rawDiff < 0 ? '#60C3F7' : '#A9D8AA']}
                        />
                    </Box>
                </Box>
                <Box display={'flex'} alignItems={'center'}>
                    <Typography variant={'subtitle2'} className={classes.diffLabel}>BAND</Typography>
                    <Box flex={1}>
                        <DiffBarChart
                            labels={['δ']}
                            data={[bandDiff]}
                            colors={[bandDiff < 0 ? '#60C3F7' : '#A9D8AA']}
                        />
                    </Box>
                </Box>
            </Box>
            <Box mt={1} display={'flex'} justifyContent={'center'} style={{paddingLeft: 60}}>
                <Typography variant={'caption'} style={{color: '#999'}}>
                    좌뇌 우세 ← 0 → 우뇌 우세
                </Typography>
            </Box>
        </Box>
    </Box>
}

/**
 * 좌우 차이 수평 바차트 (RAW / BAND)
 */
function DiffBarChart({labels, data, colors}) {
    const chartData = {
        labels,
        datasets: [{
            data,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 1,
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false,
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem) {
                    const val = tooltipItem.xLabel;
                    if (val < 0) return `좌뇌 우세: ${Math.abs(val)}`;
                    return `우뇌 우세: ${val}`;
                }
            }
        },
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    display: true,
                    color: 'rgba(0,0,0,0.08)',
                    zeroLineColor: '#333',
                    zeroLineWidth: 2,
                },
                ticks: {
                    fontColor: '#666',
                    fontSize: 11,
                    min: -50,
                    max: 50,
                    stepSize: 25,
                    callback: function (value) {
                        if (value === 0) return '0';
                        return value > 0 ? `+${value}` : `${value}`;
                    }
                },
            }],
            yAxes: [{
                display: false,
                barPercentage: 0.6,
                categoryPercentage: 0.8,
            }]
        }
    };

    return (
        <Box style={{height: 50, position: 'relative'}}>
            <HorizontalBar
                key={Math.random()}
                data={chartData}
                options={options}
            />
        </Box>
    );
}

const useStyles = makeStyles(() => ({
    diffTitle: {
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 0,
    },
    diffLabel: {
        fontWeight: 'bold',
        color: '#555',
        marginBottom: 0,
        paddingLeft: 4,
        fontSize: 14,
        minWidth: 60,
    },
}))